<template>
    <div>
        <div class="bagrcos">
            <!-- 左侧树 -->
            <div style="width:16%;height: calc(100vh - 130px);overflow-y: scroll;">
                <a-tree v-if="data.length > 0" :tree-data="data" :defaultExpandAll="true"
                    @select="(a, b) => selectNode(a, b)" :selectedKeys="selectedKeys"
                    @rightClick="(a, b) => rightClick(a, b)">
                    <template #title="{ key: treeKey, title }">
                        <a-dropdown :trigger="['contextmenu']">
                            <span>{{ title }}</span>
                            <template #overlay>
                                <a-menu @click="({ key: menuKey }) => onContextMenuClick(treeKey, menuKey)">
                                    <a-menu-item key="1">新增</a-menu-item>
                                    <a-menu-item key="2">编辑</a-menu-item>
                                    <a-menu-item key="3">删除</a-menu-item>
                                </a-menu>
                            </template>
                        </a-dropdown>
                    </template>
                </a-tree>
            </div>
            <!-- 右侧表单 -->
            <div class="add_form" v-show="type == 1">
                <div class="fotersa" style="">
                    <div v-if="screenWidth>=1860">
                        <div class="head-input" style="height: 80px;">
                        <a-form :layout="formLayout">
                            <a-row :gutter="24" type="flex" justify="start">
                                <a-col :span="6" class="fl2 fw">
                                    <a-form-item label="标签状态" :label-col="formItemLayout.labelCol"
                                        :wrapper-col="formItemLayout.wrapperCol" style="margin-bottom: 0px;">
                                        <a-select style="width: 160px" :allowClear="true" placeholder="请选择"
                                            v-model="form.labelStatus">
                                            <a-select-option v-for="item in menuStateData" :key="item.busCode"
                                                :value="item.busCode">
                                                {{ item.busName }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" class="fl2 fw">
                                    <a-form-item label="标签类型" :label-col="formItemLayout.labelCol"
                                        :wrapper-col="formItemLayout.wrapperCol">
                                        <a-select style="width: 160px" :allowClear="true" placeholder="请选择"
                                            v-model="form.labelType">
                                            <a-select-option v-for="item in labelTypeList" :key="item.busCode"
                                                :value="item.busCode">
                                                {{ item.busName }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" class="fl2 fw">
                                    <a-form-item label="标签名称" :label-col="formItemLayout.labelCol"
                                        :wrapper-col="formItemLayout.wrapperCol">
                                        <a-input placeholder="请输入标签名称" v-model="form.labelName" :allowClear="true" />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12" class="oper">
                                    <div style="height: 41px; line-height: 41px">
                                        <a-button type="primary" @click="queryList(1)">查询</a-button>
                                        <a-button type="primary" ghost @click="addModal()"
                                            style="margin-left: 10px;">新增</a-button>
                                        <a-button type="primary" @click="allUp()"
                                            style="margin-left: 10px;">批量启用</a-button>
                                        <!-- <a-button type="primary" @click="queryList(1)"></a-button> -->
                                        <a-button type="primary" @click="allDown()"
                                            style="margin-left: 10px;">批量禁用</a-button>
                                    </div>
                                </a-col>
                            </a-row>

                            <a-row :gutter="24" type="flex" justify="start">
                               


                            </a-row>
                        </a-form>
                    </div>
                    </div>
                 <div v-else>
                    <div class="head-input" style="height: 80px;">
                        <a-form :layout="formLayout">
                            <a-row :gutter="24" type="flex" justify="start">
                                <a-col :span="6" class="fl2 fw">
                                    <a-form-item label="标签状态" :label-col="formItemLayout.labelCol"
                                        :wrapper-col="formItemLayout.wrapperCol" style="margin-bottom: 0px;">
                                        <a-select style="width: 160px" :allowClear="true" placeholder="请选择"
                                            v-model="form.labelStatus">
                                            <a-select-option v-for="item in menuStateData" :key="item.busCode"
                                                :value="item.busCode">
                                                {{ item.busName }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="6" class="fl2 fw">
                                    <a-form-item label="标签类型" :label-col="formItemLayout.labelCol"
                                        :wrapper-col="formItemLayout.wrapperCol">
                                        <a-select style="width: 160px" :allowClear="true" placeholder="请选择"
                                            v-model="form.labelType">
                                            <a-select-option v-for="item in labelTypeList" :key="item.busCode"
                                                :value="item.busCode">
                                                {{ item.busName }}
                                            </a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                              
                                <a-col :span="12" class="oper">
                                    <div style="height: 41px; line-height: 41px">
                                        <a-button type="primary" @click="queryList(1)">查询</a-button>
                                        <a-button type="primary" ghost @click="addModal()"
                                            style="margin-left: 10px;">新增</a-button>
                                        <a-button type="primary" @click="allUp()"
                                            style="margin-left: 10px;">批量启用</a-button>
                                        <!-- <a-button type="primary" @click="queryList(1)"></a-button> -->
                                        <a-button type="primary" @click="allDown()"
                                            style="margin-left: 10px;">批量禁用</a-button>
                                    </div>
                                </a-col>
                            </a-row>

                            <a-row :gutter="24" type="flex" justify="start">
                               
                                <a-col :span="6" class="fl2 fw">
                                    <a-form-item label="标签名称" :label-col="formItemLayout.labelCol"
                                        :wrapper-col="formItemLayout.wrapperCol">
                                        <a-input placeholder="请输入标签名称" v-model="form.labelName" :allowClear="true" />
                                    </a-form-item>
                                </a-col>

                            </a-row>
                        </a-form>
                    </div>
                 </div>

                    <div class="base-content">

                        <div>
                            <a-table
                                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, columnWidth: '50px' }"
                                :columns="columns" :scroll="{ x: tableWidth, y: 'calc(100vh - 300px)' }"
                                :data-source="tableData" :pagination="false" :loading="Tableloading" :rowKey="(record, index) => {
                    return record.id
                                 }
                    " bordered size="small">
                                <!-- <div slot="index" slot-scope="text, record, index">
                                    {{ index + (pageNum - 1) * pageSize + 1 }}
                                </div> -->
                                <div slot="markType" slot-scope="text">
                                    {{ text.markType | DictionaryFilter("MARK_TYPE") }}
                                </div>
                                <div slot="labelStatus" slot-scope="text">
                                    <span v-if="text.labelStatus == '01'"><a-badge color="cyan" /></span>
                                    <span v-else-if="text.labelStatus == '02'"><a-badge color="red" /></span>
                                    {{ text.labelStatus | DictionaryFilter("COMMONSTATUS") }}
                                </div>
                                <div slot="labelType" slot-scope="text">
                                    {{ text.labelType | DictionaryFilter("LABEL_TYPE") }}
                                </div>
                                <!-- 操作 -->
                                <div slot="operation" slot-scope="text">
                                    <a @click="onUpdate(text)">编辑</a>
                                    <a @click="handleDelete(text)">删除</a>
                                </div>
                                <!-- <div slot="action" slot-scope="text">
                                    <a @click="modification(text)">编辑</a>
                                    <a @click="deleteClick(text)">删除</a>
                                    <a @click="up(text)">{{ text.roleStatus == 1 ? '禁用' : '启用' }}</a>
                                    <a @click="AssignUsers(text)">分配用户</a>
                                    <a @click="allocation(text)">分配菜单</a>
                                </div> -->
                            </a-table>
                        </div>

                        <div class="base-pagination">
                            <a-pagination class="table_pagination" show-size-changer :default-current="1"
                                v-model="pageNum" :show-total="(totalRows) => `共 ${totalRows} 条`"
                                :page-size-options="pageSizeOptions" size="small" :total="totalRows"
                                @showSizeChange="onShowSizeChange" @change="paginationChange"
                                :page-size.sync="pageSize" />
                        </div>
                    </div>
                </div>

            </div>
            <div class="add_form" v-show="type == 2">
                <div>
                    <h2 class="tip-icon"> {{ title }} </h2>
                </div>
                <br>
                <a-form-model ref="twoRuleForm" :model="twoFormState" :rules="twoRules" :label-col="labelCol"
                    :wrapper-col="wrapperCol">

                    <a-row>
                        <a-col :span="12">
                            <a-form-model-item label="类别名称" prop="labelname">
                                <a-input placeholder="请输入类别名称" v-model="twoFormState.labelname" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <!-- :disabled="twoFormState.parentId == '0' ? true : false"  -->
                            <a-form-model-item label="上级标签" prop="parentId">
                                <a-tree-select v-if="menuIddata.length > 0"
                                    :disabled="twoFormState.parentId == '0' ? true : false"
                                    v-model="twoFormState.parentId" style="width: 100%"
                                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="menuIddata"
                                    :treeNodeDisabledKey="'disabled'" placeholder="请输入上级标签" allow-clear
                                    tree-default-expand-all>
                                </a-tree-select>
                                <template #title="{ value: val, label }">
                                    <b v-if="val != twoFormState.parentid" style="color: #08c">sss</b>
                                    <template v-else>{{ label }}</template>
                                </template>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="12">

                            <a-form-model-item label="是否多选" prop="labelstatus">
                                <!-- <a-select show-search v-model="formState.menustatus" placeholder="请选择菜单状态">
                                    <a-select-option v-for="item in menuStateData" :key="item.value" :value="item.value">{{
                                        item.label }}</a-select-option>
                                </a-select> -->
                                <a-radio-group name="radioGroup" v-model="twoFormState.labelstatus">
                                    <a-radio :value="'1'">
                                        是
                                    </a-radio>
                                    <a-radio :value="'0'">
                                        否
                                    </a-radio>

                                </a-radio-group>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="菜单排序" prop="labelorder">
                                <a-input type="number" placeholder="请输入菜单排序" v-model="twoFormState.labelorder" />
                            </a-form-model-item>
                        </a-col>

                    </a-row>
                    <a-row>
                        <a-col :span="12">

                            <a-form-model-item label="标签类型" prop="labeltype">
                                <a-select show-search v-model="twoFormState.labeltype" placeholder="请选择标签类型">
                                    <a-select-option v-for="item in labelTypeList" :key="item.value"
                                        :value="item.value">{{
                    item.label }}</a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">

                        </a-col>

                    </a-row>

                </a-form-model>
                <a-row style="margin-left: 20%;margin-top: 30px;">
                    <a-col :span="24">
                        <a-button type="primary" @click="twoHandleOk"><span>保存</span></a-button>
                    </a-col>
                </a-row>

            </div>
            <div class="add_form" v-show="type == 3">
                <div>
                    <h2 class="tip-icon"> {{ title }} </h2>
                </div>
                <br>
                <a-form-model ref="ruleForm" :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol"
                    :rules="rules">

                    <a-row>
                        <a-col :span="12">
                            <a-form-model-item label="标签名称" prop="labelname">
                                <a-input placeholder="请输入标签名称" v-model="formState.labelname" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item label="标签编号" prop="labelorder">
                                <a-input placeholder="请输入标签编号" v-model="formState.labelorder" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="12">

                            <a-form-model-item label="标签实体" prop="labeltype">
                                <!-- <a-select show-search v-model="" placeholder="">
                                    <a-select-option v-for="item in labelLists" :key="item.value" :value="item.value">{{
                                        item.label }}</a-select-option>
                                </a-select> -->
                                <a-tree-select v-if="menuIddata.length > 0"
                                    :disabled="formState.labeltype == '0' ? true : false" v-model="formState.labeltype"
                                    style="width: 100%" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                    :tree-data="menuIddata" :treeNodeDisabledKey="'disabled'" placeholder="请选择标签实体"
                                    allow-clear tree-default-expand-all>
                                </a-tree-select>
                                <template #title="{ value: val, label }">
                                    <b v-if="val != formState.labeltype" style="color: #08c">sss</b>
                                    <template v-else>{{ label }}</template>
                                </template>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="12">

                            <a-form-model-item label="标记方式" prop="labelicon">
                                <!-- <a-select show-search v-model="formState.menustatus" placeholder="请选择菜单状态">
                                    <a-select-option v-for="item in menuStateData" :key="item.value" :value="item.value">{{
                                        item.label }}</a-select-option>
                                </a-select> -->
                                <a-radio-group name="radioGroup" v-model="formState.labelicon">
                                    <a-radio :value="'1'">
                                        手动标记
                                    </a-radio>


                                </a-radio-group>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="12">

                            <a-form-model-item label="标签状态" prop="labelstatus">
                                <a-select show-search v-model="formState.labelstatus" placeholder="请选择标签类型">
                                    <a-select-option v-for="item in menuStateData" :key="item.value"
                                        :value="item.value">{{
                    item.label }}</a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="12">


                        </a-col>
                    </a-row>
                    <a-row class="remark">
                        <a-col :span="24">
                            <a-form-model-item label="备注" prop="remark">
                                <a-textarea v-model="formState.remark" style="height: 80px;" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-form-model>
                <a-row style="margin-left: 20%;margin-top: 30px;">
                    <a-col :span="24">
                        <a-button type="primary" @click="handleOk"><span>保存</span></a-button>
                    </a-col>
                </a-row>

            </div>
        </div>
    </div>
</template>

<script>
import { labelList, labelListAdd, labelAdd, labelListDisable, labelListEnable, menuById, labelQuery, labelDelete, labelQueryId, labelUpdate, labelDeleteId, labelListId, labelListUpdate } from "@/api/api.js"
import { DictionaryService } from "@common/services/dictionary.service";

export default {
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 18 },
            data: [],
            menuIddata: [],
            values: '',
            menuData: [],
            initData: [],//左键或右键选中结点的children
            title: '标签新增',
            updateId: "",
            selectedKeys: ['1'], //默认选中节点
            form: {
                labelName: '',
                labelType: undefined,
                labelStatus: undefined
            },
            labelid: '',
            columns: [
                {
                    title: '标签编号',
                    dataIndex: 'labelNo',
                    key: 'labelNo',
                    width: 90,
                    align: "center",
                },
                {
                    title: '标签名称',
                    dataIndex: 'labelName',
                    key: 'labelName',
                    width: 90,
                    align: "center",
                },
                {
                    title: '标签类型',
                    key: 'labelType',
                    width: 100,
                    align: "center",
                    scopedSlots: { customRender: 'labelType' }
                }, {
                    title: '类型名称',
                    dataIndex: 'typeName',
                    key: 'typeName',
                    width: 100,
                    align: "center",
                },
                {
                    title: '标记方式',
                    key: 'markType',
                    width: 80,
                    align: "center",
                    scopedSlots: { customRender: 'markType' }
                },
                {
                    title: '标签状态',
                    key: 'labelStatus',
                    width: 80,
                    align: "center",
                    ellipsis: true,
                    scopedSlots: { customRender: 'labelStatus' }
                }, {
                    title: '分组',
                    dataIndex: 'labelGroup',
                    key: 'labelGroup',
                    align: "center",
                    width: 120,
                    align: "center",
                },
                {
                    title: '备注',
                    dataIndex: 'remark',
                    key: 'remark',
                    width: 120,
                    align: "center",
                },
                {
                    title: '操作',
                    key: 'operation',
                    width: 100,
                    align: "center",
                    scopedSlots: { customRender: 'operation' }
                },
            ],
            rules: {
                labelname: [
                    {
                        required: true,
                        message: "请输入标签名称",
                        trigger: "change",
                    },
                    {
                        min: 1,
                        max: 20,
                        message: '长度1-20'
                    }
                ],
                labelicon: [
                    {
                        required: true,
                        message: "请选择标记类型",
                        trigger: "change",
                    },
                ],
                labeltype: [
                    {
                        required: true,
                        message: "请选择标签实体",
                        trigger: "change",
                    },
                ],
                labeltype: [
                    {
                        required: true,
                        message: "请选择标签实体",
                        trigger: "change",
                    },
                ],
                labelorder: [
                    {
                        required: true,
                        message: "请输入标签编号",
                        trigger: "change",
                    },
                    {
                        min: 1,
                        max: 20,
                        message: '标签编号长度1-20'
                    }
                ],
                remark: [
                    {

                        max: 200,
                        message: '备注最大长度200',
                        trigger: "change",
                    }
                ]
            },
            twoRules: {
                labelname: [
                    {
                        required: true,
                        message: "请输入标签名称",
                        trigger: "change",
                    },
                    {
                        min: 1,
                        max: 20,
                        message: '标签名称长度1-20'
                    }
                ],
                parentId: [
                    {
                        required: true,
                        message: "请选择上级标签",
                        trigger: "change",
                    },
                ],
                labelstatus: [
                    {
                        required: true,
                        message: "请选择是否多选",
                        trigger: "change",
                    },
                ]
            },
            title: '菜单编辑',
            formState: {
                labelname: "",
                labelorder: "",
                labelstatus: undefined,
                labeltype: undefined,
                remark: "",
                labelicon: ''

            },
            twoFormState: {
                labelname: "",
                parentId: "",
                labelstatus: undefined,
                labelorder: '',
                labeltype: ''
            },
            delid: "",
            menuStateData: [],
            dictStatus: [],
            formLayout: "horizontal",
            selectedRowKeys: [],
            pageNum: 1,
            pageSize: 10,
            totalRows: null,
            totalPage: '',
            pageSizeOptions: ["10", "20", "50", "100"],
            Tableloading: false,
            tableData: [],
            type: 1,
            labelTypeList: [],
            labelLists: [],
            tableWidth:0,
            screenWidth:''
        }
    },
    computed: {
        formItemLayout() {
            const { formLayout } = this;
            return formLayout === "horizontal"
                ? {
                    labelCol: { span: 6 },
                    wrapperCol: { span: 18 },
                }
                : {};
        },
    },
    mounted() {
        const myremark = document.querySelector('.remark').querySelector('.ant-form-item-label')
        const myrInput = document.querySelector('.remark').querySelector('.ant-form-item-control-wrapper')
        myremark.classList.add('ant-col-2');
        myremark.classList.remove('ant-col-5');
        myrInput.classList.add('ant-col-22');
        myrInput.classList.remove('ant-col-18');
        const myremark1 = document.querySelector('.remark').querySelector('.ant-col-2')
        myremark1.style.width = '9.45% '
        const myrInput1 = document.querySelector('.remark').querySelector('.ant-col-22')
        myrInput1.style.width = '90.55%'
        this.tableWidth = 0;
      this.columns.map(item => {
        this.tableWidth += item.width;
      });
      console.log(this.tableWidth,'this.tableWidth')
        // 获取列表数据
        this.searchList()
        // 获取表格数据
        this.queryList(1)
        // 字典调用获取菜单状态
        DictionaryService.getAllNeedDic(["USE_STATUS", "MENU_STATUS", 'LABEL_TYPE', 'COMMONSTATUS', 'MARK_TYPE']).then((res) => {
            this.menuStateData = DictionaryService.getOptions("COMMONSTATUS");
            this.dictStatus = DictionaryService.getOptions("USE_STATUS");
            this.labelTypeList = DictionaryService.getOptions('LABEL_TYPE')
            // this.values = this.menuStateData
        });
       

    },
    created() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  },
  destroyed() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  },
    methods: {
        updateWindowDimensions() {
      this.screenWidth = window.innerWidth;
    console.log( this.screenWidth,'---------')
    },
        queryList(sum = 2) {
            if (sum == 1)
                this.pageNum = 1
            this.Tableloading = true
            let pageParam = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                orderBy: '',
            }
            labelQuery({ pageParam: pageParam, content: { labelName: this.form.labelName, labelStatus: this.form.labelStatus, labelType: this.form.labelType, entityId: this.updateId||'0' } }).then(
                (res) => {
                    console.log(res.content.rows,'res.content.rows')
                    this.Tableloading = false
                    this.tableData = res.content.rows
                    this.totalRows = res.content.page.totalRows
                    this.totalPage = Math.ceil(this.totalRows / this.pageSize)
                },
                (err) => {
                    this.$message.error('查询失败')
                    this.Tableloading = false
                }
            )
        },

        allUp() {

            if (this.selectedRowKeys.length <= 0) {
                this.$message.warning('请选择至少一条标签');
            } else {
                this.$confirm({
                    title: "是否批量启用?",
                    okText: "是",
                    cancelText: "否",
                    onOk: () => {
                        let obj = {
                            ids: this.selectedRowKeys
                        };
                        labelListEnable(obj).then((res) => {
                            this.queryList();
                            this.selectedRowKeys = []
                            // this.selectedKeys.splice(0)
                            // this.selectedKeys.push('1')
                        }, (err) => {
                        })
                    },
                    onCancel: () => { },
                });
            }
        },
        allDown() {
            if (this.selectedRowKeys.length <= 0) {
                this.$message.warning('请选择至少一条标签');
            } else {
                this.$confirm({
                    title: "是否批量禁用?",
                    okText: "是",
                    cancelText: "否",
                    onOk: () => {
                        let obj = {
                            ids: this.selectedRowKeys
                        };
                        labelListDisable(obj).then((res) => {
                            this.queryList();
                            this.selectedRowKeys = []
                            // this.selectedKeys.splice(0)
                            // this.selectedKeys.push('1')
                        }, (err) => {
                        })
                    },
                    onCancel: () => { },
                });
            }
        },
        onSelectChange(data, selectedRows) {
            this.selectedRows = selectedRows;
            this.selectedRowKeys = data;
        },
        paginationChange(page, pageSize) {
            console.log(page,'1111')
            this.pageNum = page;
            this.queryList();
        },
        onShowSizeChange(current, size) {
            this.pageSize = size;
            this.pageNum = 1;
            this.queryList();
        },
        // 左侧列表树右击菜单事件
        onContextMenuClick(treeKey, menuKey) {

            this.selectedKeys.splice(0)
            this.updateId = treeKey
            console.log( this.updateId,' this.updateId')
            this.selectedKeys.push(treeKey)
            let id = treeKey
            if (menuKey == '1') {
                this.twoFormState.parentId = treeKey
                this.type = 2
                this.title = '标签实体新增'
                this.$refs["twoRuleForm"].resetFields();

                // this.formState.parentid = treeKey
                labelQueryId({ id: id }).then(res => {


                    // this.twoFormState.labelname = res.content.typeName
                    this.twoFormState.parentId = res.content.id
                    // this.twoFormState.labelstatus = res.content.choiceType
                    // this.twoFormState.labelorder = res.content.orderNumber
                    // this.twoFormState.labeltype = res.content.labelType

                })
                this.menuIddata.map(item=>{
            item.disabled = false
            if(item.children[0]){
                item.children.map((items)=>{
                    items.disabled = false
                    if(items.children[0]){
                        items.children.map((itemss)=>{
                            itemss.disabled = false
                            if(itemss.children[0]){
                                itemss.children.map((itemsss)=>{
                                    itemsss.disabled = false})
                            }
                        })
                    }
                })
            }
        })
                this.traverse(this.menuIddata)

            } else if (menuKey == '2') {

                this.type = 2
                this.title = '标签实体编辑'


                this.$refs["twoRuleForm"].resetFields();
                labelQueryId({ id: id }).then(res => {


                    this.twoFormState.labelname = res.content.typeName
                    this.twoFormState.parentId = res.content.id
                    this.twoFormState.labelstatus = res.content.choiceType
                    this.twoFormState.labelorder = res.content.orderNumber
                    this.twoFormState.labeltype = res.content.labelType
                  
                })
                this.menuIddata.map(item=>{
            item.disabled = false
            if(item.children[0]){
                item.children.map((items)=>{
                    items.disabled = false
                    if(items.children[0]){
                        items.children.map((itemss)=>{
                            itemss.disabled = false
                            if(itemss.children[0]){
                                itemss.children.map((itemsss)=>{
                                    itemsss.disabled = false})
                            }
                        })
                    }
                })
            }
        })
                this.traverse(this.menuIddata)
                // this.$refs["ruleForm"].resetFields();
                // this.formState.parentid = treeKey

            } else if (menuKey == '3') {
                this.$confirm({
                    title: "确定是否删除?",
                    okText: "是",
                    cancelText: "否",
                    onOk: () => {
                        let obj = {
                            id: id
                        };
                        labelDelete(obj).then((res) => {
                            this.searchList();
                            // this.selectedKeys.splice(0)
                            // this.selectedKeys.push('1')
                        }, (err) => {
                        })
                    },
                    onCancel: () => { },
                });
            }
        },
        handleDelete(item) {
            this.$confirm({
                title: "确定是否删除?",
                okText: "是",
                cancelText: "否",
                onOk: () => {
                    let obj = {
                        id: item.id
                    };
                    labelDeleteId(obj).then((res) => {
                        this.queryList();
                        // this.selectedKeys.splice(0)
                        // this.selectedKeys.push('1')
                    }, (err) => {
                    })
                },
                onCancel: () => { },
            });
        },
        // 右键单机树节点
        rightClick({ event, node }) {

        },
        // 菜单列表查询
        searchList() {


            labelList({}).then((res) => {


                if (res.content[0]) {
                    res.content.map(item => {

                        let str = item.typeName + ':' + item.choiceType == '1' ? '是' : item.choiceType == '0' ? '否' : '' + '(' + item.labelCount + ')'
                        this.labelLists.push({ 'label': str, 'value': item.id })
                    })
                }
                this.menuData = res.content
                this.getTreemenu(res.content, 0)
                this.getTree(res.content, 0)
            }).then((res) => {
                this.traverse(this.menuIddata)
            })
        },
        addModal() {
            this.$refs["ruleForm"].resetFields();
            this.title = '标签新增'
            this.type = 3
          
        this.formState.labeltype =this.updateId
        this.menuIddata.map(item=>{
            item.disabled = false
            if(item.children[0]){
                item.children.map((items)=>{
                    items.disabled = false
                    if(items.children[0]){
                        items.children.map((itemss)=>{
                            itemss.disabled = false
                            if(itemss.children[0]){
                                itemss.children.map((itemsss)=>{
                                    itemsss.disabled = false})
                            }
                        })
                    }
                })
            }
        })
                // this.traverse(this.menuIddata)
                // this.initData = []
          
        },
        onUpdate(item) {
            this.$refs["ruleForm"].resetFields();
            this.title = '标签编辑'
            this.type = 3
            this.labelid = item.id
          
            labelListId({ id: item.id }).then(res => {

                this.formState.labeltype = res.content.entityId
                this.formState.labelname = res.content.labelName
                this.formState.labelorder = res.content.labelNo
                this.formState.labelicon = res.content.markType
                this.formState.labelstatus = res.content.labelStatus
                this.formState.remark = res.content.remark
               
                this.menuIddata.map(item=>{
            item.disabled = false
            if(item.children[0]){
                item.children.map((items)=>{
                    items.disabled = false
                    if(items.children[0]){
                        items.children.map((itemss)=>{
                            itemss.disabled = false
                            if(itemss.children[0]){
                                itemss.children.map((itemsss)=>{
                                    itemsss.disabled = false})
                            }
                        })
                    }
                })
            }
        })
        this.updateId = res.content.entityId
                this.traverse(this.menuIddata)
                
            })
          
        },
        // 树型下拉菜单列表获取
        getTree(data, parentId, updateId) {
            var streeMenu = [];
            for (var i = 0; i < data.length; i++) {
                var node = data[i];
                if (data[i].parentId == parentId) {
                    var newTree = {
                        key: node.id,
                        title: node.typeName,
                        value: node.id,
                        parentid: node.parentId,
                        children: this.getTree(data, node.id),
                    };
                    streeMenu.push(newTree);
                }
            }
            this.menuIddata = streeMenu;
            return streeMenu;
        },
        // 树型菜单列表获取
        getTreemenu(data, parentId) {
            var treeMenu = [];
            var streeMenu = [];
            for (var i = 0; i < data.length; i++) {
                var node = data[i]

                let type = +node.choiceType == '1' ? '多选' : '单选'
                let str = '(' + node.labelCount + ')'

                if (data[i].parentId == parentId) {
                    var newTree = {
                        key: node.id,
                        title: node.typeName + ' ：' + type + str,
                        mlink: node.menuLink,
                        children: this.getTreemenu(data, node.id)
                    };

                    treeMenu.push(newTree)

                }
            }
            this.data = treeMenu
            return treeMenu
        },
        twoHandleOk(e) {
            if (this.title === '标签实体新增') {
                this.$refs.twoRuleForm.validate((valid) => {
                    if (valid) {

                        labelAdd({
                            "typeName": this.twoFormState.labelname,
                            "parentId": this.twoFormState.parentId,
                            "choiceType": this.twoFormState.labelstatus,
                            "orderNumber": this.twoFormState.labelorder,
                            'labelType': this.twoFormState.labeltype
                        })
                            .then(
                                (res) => {
                                    if (res.code == "0000") {
                                        this.$message.success("操作成功");
                                        //刷新当前页面
                                        location.reload();
                                        this.searchList()
                                        this.$refs["twoRuleForm"].resetFields();
                                    } else {
                                    }
                                },
                                (err) => {

                                }
                            );

                    }
                });
            } else {
                this.$refs.twoRuleForm.validate((valid) => {
                    if (valid) {
                        labelUpdate({
                            "id": this.updateId,
                            "typeName": this.twoFormState.labelname,
                            "parentId": this.twoFormState.parentId,
                            "choiceType": this.twoFormState.labelstatus,
                            "orderNumber": this.twoFormState.labelorder,
                            'labelType': this.twoFormState.labeltype
                        })
                            .then(
                                (res) => {
                                    if (res.code == "0000") {
                                        this.$message.success("操作成功");
                                        //刷新当前页面
                                        location.reload();
                                        this.searchList()
                                        this.updateId = ''
                                        this.$refs["twoRuleForm"].resetFields();
                                    } else {
                                    }
                                },
                                (err) => {

                                }
                            );

                    }
                });
            }
        },
        //新增、编辑
        handleOk(e) {

            if (this.title === '标签新增') {

                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        labelListAdd({

                            'entityId': this.formState.labeltype,
                            "labelName": this.formState.labelname,
                            "labelNo": this.formState.labelorder,
                            "markType": this.formState.labelicon,
                            "labelStatus": this.formState.labelstatus,
                            "remark": this.formState.remark
                        })
                            .then(
                                (res) => {

                                    if (res.code == "0000") {
                                        this.$message.success("操作成功");
                                        //刷新当前页面
                                        location.reload();
                                        this.searchList()

                                        this.$refs["ruleForm"].resetFields();
                                    } else {
                                    }
                                },
                                (err) => {

                                }
                            );

                    } else {

                    }
                });
            } else {
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        labelListUpdate({
                            'id': this.labelid,
                            'entityId': this.formState.labeltype,
                            "labelName": this.formState.labelname,
                            "labelNo": this.formState.labelorder,
                            "markType": this.formState.labelicon,
                            "labelStatus": this.formState.labelstatus,
                            "remark": this.formState.remark
                        })
                            .then(
                                (res) => {

                                    if (res.code == "0000") {
                                        this.$message.success("操作成功");
                                        //刷新当前页面
                                        location.reload();
                                        this.searchList()
                                        this.labelid = ''
                                        this.$refs["ruleForm"].resetFields();
                                    } else {
                                    }
                                },
                                (err) => {

                                }
                            );

                    } else {

                    }
                });
            }
        },

        // 左键单机树节点
        selectNode(key, e) {
            
            let keys = [e.node.eventKey];
            this.selectedKeys.splice(0)
            this.selectedKeys = keys
            this.selectedRowKeys = []
            // this.formState.labeltype = keys
           console.log(e.node.eventKey,'this.updateId')
    // if(key[0]){
    //     console.log('111')
    //     this.updateId = keys
    // }else{
    //     console.log('222')
        this.updateId = e.node.eventKey
    // }
            this.type = 1
            this.pageNum = 1
            this.Tableloading = true
            let pageParam = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                orderBy: '',
            }
            labelQuery({ pageParam: pageParam, content: { entityId: e.node.eventKey } }).then(
                (res) => {
                    this.Tableloading = false
                    this.tableData = res.content.rows
                    this.totalRows = res.content.page.totalRows
                    this.totalPage = Math.ceil(this.totalRows / this.pageSize)
                },
                (err) => {
                    this.$message.error('查询失败')
                    this.Tableloading = false
                })
        },

        // 禁用效果实现
        traverse(data) {
            for (let i = 0; i < data.length; i++) {
                var node = data[i]

                if (node.key == this.updateId) {

                    node.disabled = true
                    this.initData = node
                    this.againTraverse(this.initData.children)
                }
                this.traverse(data[i].children);
            }
            this.menuIddata = data
        },
        againTraverse(node) {
            for (let item of node) {
                item.disabled = true
                if (item.children && item.children.length) {
                    this.againTraverse(item.children)
                }
            }
            return node
        },
        //查询单个菜单
        searchOne(treeid) {
            this.menuData.forEach(item => {
                if (item.id == treeid) {
                    menuById({ id: item.id }).then((res) => {
                        this.twoFormState.menuname = res.content.menuIcon
                        this.twoFormState.menuorder = res.content.menuLink
                        this.twoFormState.menustatus = res.content.menuName
                    })

                }

            });
        }
    },
}
</script>

<style scoped lang="less">
@import url('../../../../common/css/antd-table.less');


.base-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/deep/.ant-table-body {
    margin-top: -8px !important;
}

.sp_name {
    display: inline-block;
    font-size: 20px;
    margin: 0 0 20px 10px;
}

.fotersa {
    width: 100%;
    height: 100%;
    overflow-y: hidden;

    .title-name {
        width: 100%;
        height: 46px;
        overflow: hidden;

        .sp_name {
            display: inline-block;
            font-size: 20px;
            margin: 0 0 20px 10px;
        }
    }

    .flex {
        display: flex;
        align-items: center;
    }

    .flex label {
        font-size: 16px;
        width: 73px;
    }

    .btone {
        margin-left: 10px;
    }

    .bttwo {
        margin-left: 10px;
    }

    a {
        margin-left: 10px;
    }

    a:hover {
        color: #70b9cf;
    }
}

.title-name::before {
    content: "";
    width: 5px;
    height: 20px;
    display: inline-block;
    overflow: hidden;
    background-color: #0b2464;
}

/deep/ .ant-table-body {
    max-height: 487px;
    overflow: auto;
    margin: 0 !important;
}

/deep/.ant-table-tbody>tr>td {
    padding: 11px 16px;
}

.add-mess {
    width: 100%;
    //overflow: auto;

    /deep/ .ant-form-item {
        display: flex;
        margin-bottom: 20px !important;
    }

    /deep/ .ant-form-item-label {
        width: 150px;
    }

}

/deep/ .form .ant-input,
.ant-form-item-control,
.ant-form-item-control-wrapper {
    width: 160px;
}

.fw {
    width: 245px;
}

.oper {
    // flex: 1;
    width: 200px;
}

/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
    width: 76px;
}

/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
    width: 72px;
}

/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
    width: 68px;
}

/deep/ .ant-input-affix-wrapper {
    width: 160px;
}

/deep/ .ant-col-18 {
    width: 65%;
}

/deep/ .ant-col-12 {
    width: 45%;
}

/deep/.ant-col-20 {
    width: 82%;
}

.table_pagination {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.base-pagination {
    float: right;
}

.base-content {
    margin-top: 10px;
    // width: 1007px;
    // width: calc(100%-300px);
}

.ant-btn-primary {
    background: rgba(255, 255, 255, 1);
    color: rgba(22, 130, 139, 1);
}

.ant-btn-primary:hover,
.ant-btn-primary:focus {
    background: rgba(22, 130, 139, 1);
    border-color: rgba(22, 130, 139, 1);
    color: rgba(255, 255, 255, 1);
}

.appraisement-box {
    .header-edit {
        padding: 0 3%;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .edit {
            display: flex;
        }
    }
}

.header {
    display: flex;
    justify-content: space-between;
}

.bagrcos {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    margin-top: 10px;



    .add_form {
        width: 80%;

        flex: 1;
        h2 {
            font-size: medium;
        }

        margin-left:30px;
    }
}

/deep/ .ant-row-flex-start {
    justify-content: flex-start;
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-bottom: -24px !important;
}
</style>
